/**
 * useIndustry — hook per leggere e aggiornare tenants.settings.industry.
 *
 * OB.1: salva la selezione industry del tenant in settings JSONB via PATCH.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTenant } from './useTenant'
import { api } from '../lib/api'
import type { IndustrySlug } from '../lib/industries'

/** Legge l'industry corrente del tenant (null se non impostata). */
export function useCurrentIndustry(): IndustrySlug | null {
  const { data: tenant } = useTenant()
  const slug = tenant?.settings?.industry
  return (slug as IndustrySlug) ?? null
}

/** Aggiorna tenants.settings.industry via PATCH /api/v1/tenants/me. */
export function useUpdateIndustry() {
  const queryClient = useQueryClient()
  return useMutation<void, Error, IndustrySlug | null>({
    mutationFn: async (industry) => {
      await api.patch('/api/v1/tenants/me', { settings: { industry } })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tenant'] })
    },
  })
}
